// extracted by mini-css-extract-plugin
export default {"root":"Progress_root__x-ZC0","cell":"Progress_cell__gp+B8"};